// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".ac06fa26d494e5d06831c5caaa2ca122f2f1a3fb.chunk.js";
};